class Speakers {
	constructor() {
		console.log("test");
		this.variables();
		this.bindEvents();
	}

	variables(){
	}

	bindEvents() {
		$(document).on('click', '.open-speakers-detail', this.loadSpeakersDetailed);
		$(document).on('click', '.programme-single .speakers-list a', this.loadSpeakersDetailed);
	}

	loadSpeakersDetailed(e) {
		e.preventDefault();
		console.log("test");
		let getId = $(this.hash);

		getId.slideDown();
		$('body').addClass('no-scroll');

		getId.find('.close-icon').on('click', function (e) {
			e.preventDefault();
			getId.slideUp();
			$('body').removeClass('no-scroll');
		});


	}

}